import React from 'react'
import { FlexContainer, PureSpinner } from 'heliocor-ui'

import Logo from './Logo'
import { RELEASE_NUM } from '../config/domain';
import 'styled-components/macro'

const SpinnerLogo = ({dokstor}) => (
    <FlexContainer column justifyContent='center' alignItems='center' height='100vh' width='100vw'>
        <PureSpinner margin='1rem'/>
        <Logo dokstor={dokstor}/>
        <p css='font-size: 10px; color: lightgrey; text-align: center;'>{RELEASE_NUM}</p>
    </FlexContainer> 
)

export { SpinnerLogo }